export const geraPergundaSatisfacaoClube = modalidade => {
  const tituloModalidade = modalidade.charAt( 0 ).toUpperCase() + modalidade.slice( 1 )
  return `Qual seu nível de satisfação com a TAG ${tituloModalidade}?`
}


export const LEGENDA_NIVELAMENTO = 'Sendo 1 totalmente insatisfeito e 10 totalmente satisfeito'

export const LISTA_NOTAS = [
  {
    'cor': '#8a3838',
    'nota': 1
  },
  {
    'cor': '#a74242',
    'nota': 2
  },
  {
    'cor': '#c24c4c',
    'nota': 3
  },
  {
    'cor': '#da5d51',
    'nota': 4
  },
  {
    'cor': '#ee675a',
    'nota': 5
  },
  {
    'cor': '#ee875a',
    'nota': 6
  },
  {
    'cor': '#eea85a',
    'nota': 7
  },
  {
    'cor': '#eed75a',
    'nota': 8
  },
  {
    'cor': '#85cc49',
    'nota': 9
  },
  {
    'cor': '#60bb53',
    'nota': 10
  }
]
